import { render, staticRenderFns } from "./IndexFormula.vue?vue&type=template&id=044765d8&"
import script from "./IndexFormula.vue?vue&type=script&lang=js&"
export * from "./IndexFormula.vue?vue&type=script&lang=js&"
import style0 from "./IndexFormula.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports